import { render, staticRenderFns } from "./DischargeReasonCrud.vue?vue&type=template&id=3e4290f3&"
import script from "./DischargeReasonCrud.vue?vue&type=script&lang=js&"
export * from "./DischargeReasonCrud.vue?vue&type=script&lang=js&"
import style0 from "./DischargeReasonCrud.vue?vue&type=style&index=0&id=3e4290f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports